import React from 'react'
import InvitePeople from 'src/app/InvitePeople/InvitePeople'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { invitePeopleRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const InvitePeopleAppRoute: AppRoute = {
  id: AppLocation.InvitePeople,
  routeProps: invitePeopleRouteProps,
  component: <InvitePeople />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default InvitePeopleAppRoute
